import { Pipe, PipeTransform } from '@angular/core';
import { PassengerType } from '../enums';

@Pipe({
  standalone: true,
  name: 'passengerType',
})
export class PassengerTypePipe implements PipeTransform {
  transform(value: PassengerType): string {
    switch (value) {
      case PassengerType.Adult:
        return 'Người lớn';
      case PassengerType.Child:
        return 'Trẻ em';
      case PassengerType.Infant:
        return 'Em bé';
      default:
        return '';
    }
  }
}
